import Resizer from "react-image-file-resizer";

const resizeUserAvatarImage = (file, ext) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      600,
      600,
      ext,
      80,
      0,
      (uri) => {
        resolve(uri);
      },
      "file"
    );
  });

const resizeThumbnailImage = (file, ext) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      100,
      100,
      ext,
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "file",
      100
    );
  });

const resizeClientProfileImage = (file, ext) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      720,
      720,
      ext,
      80,
      0,
      (uri) => {
        resolve(uri);
      },
      "file"
    );
  });

const resizeWelcomePackImage = (file, ext) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      600,
      321,
      ext,
      80,
      0,
      (uri) => {
        resolve(uri);
      },
      "file"
    );
  });

const resizePerkHeaderImage = (file, ext) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      1920,
      1180,
      ext,
      80,
      0,
      (uri) => {
        resolve(uri);
      },
      "file"
    );
  });

const resizePerkFeaturedImage = (file, ext) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      900,
      500,
      ext,
      80,
      0,
      (uri) => {
        resolve(uri);
      },
      "file"
    );
  });

export {
  resizeUserAvatarImage,
  resizeThumbnailImage,
  resizeClientProfileImage,
  resizeWelcomePackImage,
  resizePerkFeaturedImage,
  resizePerkHeaderImage,
};
